import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { LeafBlock } from '../leaf-block.js'
import { PreviewType } from '../block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import {
	type LanguageSwitcherText,
	LanguageSwitcherTexts,
	type LanguageSwitcherType,
	LanguageSwitcherTypes,
} from '../../consts.js'

@jsonClass('LanguageSwitcherBlock')
export class LanguageSwitcherBlock extends LeafBlock {
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 1,
		label: 'Show list as',
		options: Object.entries(LanguageSwitcherTypes),
	})
	showListAs: LanguageSwitcherType = 'pipeSeparated'

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 1,
		label: 'Show language as',
		options: Object.entries(LanguageSwitcherTexts),
	})
	showLanguageAs: LanguageSwitcherText = 'shortNames'

	constructor(init: Partial<LanguageSwitcherBlock> = {}) {
		super()
		this.init(init)
	}

	producePreview(): PreviewType {
		return 'en | de | ...'
	}

	getEditorCategory(): string {
		return 'Others'
	}
}
